import { GADataProps } from "@components/GAData/GAData";
import CampaignTemplateBudget from "@routes/Keyword/templates/CampaignTemplate/CampaignTemplateBudget";
import TemplateKeywordDefault from "@routes/Keyword/templates/TemplateKeywordDefault/TemplateKeywordDefault";
import { KeywordPageData } from "@routes/Keyword/utils/types";

type KeywordPageContentProps = KeywordPageData & {
  gaProps: GADataProps;
};

/** The content of the keyword page. Separated by template. */
const KeywordPageContent = ({
  gaProps,
  ...data
}: KeywordPageContentProps): React.ReactElement => {
  if (data.template === "campaignTemplate1Budget") {
    return <CampaignTemplateBudget {...data} gaProps={gaProps} />;
  }

  return <TemplateKeywordDefault {...data} gaProps={gaProps} />;
};

export default KeywordPageContent;
